import React from "react"
import { RadioElement } from "../../../styles/form-elements"
import {
  Label,
  LabelWrapper,
  LabelOptional,
  RadioWrapper,
  GroupWrapper,
} from "../styles"
import { Controller } from "react-hook-form"

const RadioGroup = ({
  control,
  defaultValue,
  label,
  required,
  name,
  group,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        return (
          <LabelWrapper as="div">
            <Label>
              {label} {!required && <LabelOptional>optional</LabelOptional>}
            </Label>
            <GroupWrapper>
              {group.map((option, i) => {
                return (
                  <RadioWrapper key={i} selected={value === option}>
                    <RadioElement checked={value === option} />
                    <Label>{option}</Label>
                    <input
                      type="radio"
                      style={{
                        clip: 'rect(0 0 0 0)',
                        clipPath: 'inset(50%)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px',
                      }}
                      onChange={(e) => {
                        onChange(e.target.value)
                      }}
                      value={option}
                      defaultValue={defaultValue}
                      checked={value === option}
                      // {...register(name)}
                    />
                  </RadioWrapper>
                )
              })}
            </GroupWrapper>
          </LabelWrapper>
        )
      }}
    />
  )
}

export default RadioGroup
